import {
	Directive,
	EventEmitter,
	HostBinding,
	HostListener,
	Input,
	Output,
} from '@angular/core';


@Directive({
	selector: '[appDnd]',
})
export class DndDirective {
	@Output() fileDropped = new EventEmitter<any>();
	accept: string = 'image/png, image/jpeg, .docx, .xlsx, .pdf, .zip';
	maxFileSize: number = 500000 ;//max file size 50MB

	@HostBinding('style.background-color') private background = '#f9fafb';
	@HostBinding('style.opacity') private opacity = '1';

	@HostListener('dragover', ['$event']) onDragOver(evt: DragEvent) {
		evt.preventDefault();
		evt.stopPropagation();
		this.background = '#e2eefd';
		this.opacity = '0.8';
	}

	@HostListener('dragleave', ['$event']) public onDragLeave(evt: DragEvent) {
		evt.preventDefault();
		evt.stopPropagation();
		this.background = '#f9fafb';
		this.opacity = '1';
	}

	@HostListener('drop', ['$event']) public onDrop(evt: DragEvent) {
		evt.preventDefault();
		evt.stopPropagation();
		this.background = '#f9fafb';
		this.opacity = '1';
		const files = evt.dataTransfer?.files;
		if (files && files.length > 0) {
			const allowedExtensions = this.accept.split(',').map((ext) => ext.trim());
			const validFiles = Array.from(files).filter((file) => {
				if (file) {
					const extension = file.type;
					const fileSize = file.size / 100;
					return (
						allowedExtensions.includes(extension) &&
						fileSize <= this.maxFileSize
					);
				}

				return false;
			});
			this.fileDropped.emit(validFiles);
		}
	}
}
